import type { ChangelogFormatter } from '../../types';
import createMarkdownBuffer from './markdownBuffer';
import createTemplates from '../templates';
import MD from './markdown';
import format from '../textBasedFormatter';


const markdownFormatter: ChangelogFormatter<string> = ({
  A,
  B,
  changesByActionPublicId,
  featureFlags,
}) => {
  const markdownBuffer = createMarkdownBuffer();
  const templates = createTemplates({ atoms: MD, featureFlags });

  return format({
    A,
    B,
    changes: Object.values(changesByActionPublicId).flat(),
    processingBuffer: markdownBuffer,
    templates,
  });
};


export default markdownFormatter;
